export default __webpack_public_path__ + "static/miracle-mask-mobile-31d112edf5e8b7a252d3530e8a29a3ff.mp4";